// MyProcesses.js
import React, { useCallback, useEffect, useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";
import Tooltip from '../../components/utils/Tooltip';

const MyProcesses = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();

  const navigate = useNavigate();
  const userId = authState.user._id;
  const [createdProcess, setCreatedProcess] = useState([]);
  const [hasCretaedProcessStatus, setHasCretaedProcessStatus] = useState(false);
  const [hasCretaedProcessStatusMsg, setHasCretaedProcessStatusMsg] = useState('');
  const [selectedProcessId, setSelectedProcessId] = useState([]);
  const [selectedViewMemberProcessId, setSelectedViewMemberProcessId] = useState(false);
  const [selectedAddMemberProcessId, setSelectedAddMemberProcessId] = useState(false);

  const [hasNewMemberCodeClicked, setHasNewMemberCodeClicked] = useState(false);
  // const [newMemberCode, setNewMemberCode] = useState('');

  const [newMemberCodeStatus, setNewMemberCodeStatus] = useState(false);
  const [newMemberCodeStatusMsg, setNewMemberCodeStatusMsg] = useState('');
  const [newMemberCode, setNewMemberCode] = useState('');
  const [newMemberId, setNewMemberId] = useState('');
  const [newMemberName, setNewMemberName] = useState('');
  const [newMemberEmail, setNewMemberEmail] = useState('');
  const [newMemberCodeMsg, setNewMemberCodeMsg] = useState('');
  const [verifyNewMemberCodeButtonClicked, setVerifyNewMemberCodeButtonClicked] = useState(false);
  const [error, setError] = useState('');
  const [addNewButtonClickedStatus, setAddNewButtonClickedStatus] = useState(false);
  const [addNewMemberRecordStatus, setAddNewMemberRecordStatus] = useState(false);
  const [addNewMemberRecordStatusMsg, setAddNewMemberRecordStatusMsg] = useState('');

  useEffect(() => {
    fetchMyProcessList(); 
  }, []);

   const fetchMyProcessList = useCallback(() => {
    // console.log("fetchMyProcessList for API call ", userId);
    const config = {
        url: "/myprocess/mycreatedlist",
        method: "post",
        headers: { Authorization: authState.token },
        data: { createdBy: userId }
    };
  
    fetchData(config)
        .then(response => {
          // console.log("API Response: ", response); 
            if (response && response.status) {
                // console.log("process list found ", response);
                setHasCretaedProcessStatus(true);
                setCreatedProcess(response.process);
                setHasCretaedProcessStatusMsg("Processes found. 😊");
            } else {
                // console.log("Processes Code Not found");
                setHasCretaedProcessStatusMsg(`Processes not found! 😔`);
            }
        })
        .catch(error => {
            // console.log("Processes Not found!", error);
            setHasCretaedProcessStatusMsg("Error in getting data");
        });
  }, [fetchData, authState.token]);
  
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
  }, [authState.isLoggedIn, fetchMyProcessList]);

// here
const newMemberCodeValidationClicked = (newMemberCode) => {
  if (/^TU[a-zA-Z0-9]{12}$/.test(newMemberCode)) {
      fetchNewMemberCode(newMemberCode);
  } else {
      setError('Please enter a valid 14-character Think5Whys User Code starting with TU');
  }
};

const handleNewMemberCodeValidation = () => {
  setVerifyNewMemberCodeButtonClicked(true);
};

const fetchNewMemberCode = useCallback((newMemberCode) => {
  // console.log("newMemberCode for API call ", newMemberCode);
  const config = {
      url: "/auth/verifyt5wcode",
      method: "post",
      headers: { Authorization: authState.token },
      data: { think5whyscode: newMemberCode }
  };

  fetchData(config)
      .then(response => {
          if (response && response.status) {
              // console.log("newMemberCode found ", response);
              setNewMemberCodeStatus(true);
              setNewMemberId(response.t5wcode._id);
              setNewMemberName(response.t5wcode.name);
              setNewMemberCodeStatusMsg(`User Code ${newMemberCode} found. 😊`);
          } else {
              // console.log("User Not found");
              setNewMemberCodeStatus(false);
              setNewMemberCodeStatusMsg(`User Code ${newMemberCode} not found! 😔 Make sure the User Code is valid.`);
          }
      })
      .catch(error => {
          // console.log("newMemberCode Not found!");
          setNewMemberCodeStatus(false);
          setNewMemberCodeStatusMsg(`User Code ${newMemberCode} not found! 😔 Make sure the User Code is valid.`);
      });
}, [authState.token, fetchData, setNewMemberCodeStatus,setNewMemberId,setNewMemberName,setNewMemberName]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchNewMemberCode]);
//


const addNewButtonClicked = (processid, processCode, processTitle, processType, newMemberId, newMemberCode, newMemberName) => {
    setAddNewButtonClickedStatus(true);
    addNewMemberRecord(processid, processCode, processTitle, processType, newMemberId, newMemberCode, newMemberName);
};

const addNewMemberRecord = useCallback((processid, processCode, processTitle, processType, newMemberId, newMemberCode, newMemberName) => {
  // console.log("fetchAddNewMemberRecord for API call ", processid, processCode, processTitle, processType, newMemberId, newMemberCode, newMemberName);
  const newMemberData = {
    processId: processid, 
    processCode: processCode, 
    processTitle: processTitle,
    processType: processType,
    creatorCode: authState.user.think5whyscode,
    creatorName: authState.user.name,
    dateCreated: new Date(),
    memberId: newMemberId,
    memberCode: newMemberCode,
    memberName: newMemberName,
    remarks: "New Member "+newMemberName+" Joined in the Process "+processTitle,
    createdBy: authState.user._id,
    isActive: 1,
    isDeleted: 0
  };

  const config = {
      url: "/myprocess/addnewmember",
      method: "post",
      headers: { Authorization: authState.token },
      data: { newMemberData }
  };
  // console.log("fetchAddNewMemberRecord for config call ", config);

  fetchData(config)
      .then(response => {
          if (response && response.status) {
              // console.log("newMemberCode added ", response);
              setAddNewMemberRecordStatus(true);
              setAddNewMemberRecordStatusMsg(`Process Member ${newMemberName} Added. 😊`);
          } else {
              // console.log("User Not added");
              setAddNewMemberRecordStatusMsg(`Process Member ${newMemberName} not added! 😔 Please retry.`);
          }
      })
      .catch(error => {
          // console.log("newMemberCode Not added!");
          setAddNewMemberRecordStatusMsg(`Process Member ${newMemberName} not added! 😔 Please retry.`);
      });
}, [fetchData, setAddNewMemberRecordStatus]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, addNewMemberRecord]);

//

  const handleCreateProcessClick = () => {
    navigate("/myprofile-createprocess");
  };

  const handleProcessView = (_id) => {
    setSelectedProcessId(prevId => (prevId === _id ? null : _id));
  };

  const handleAddMembers = (_id) => {
    setSelectedAddMemberProcessId(prevId => (prevId === _id ? null : _id));
  };

  const handleViewMembers = (_id) => {
    setSelectedViewMemberProcessId(prevId => (prevId === _id ? null : _id));
  };

  const formatDateTime = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const processTypeNames = {
    TEA: "Team",
    DEP: "Departmental",
    BRA: "Branch",
    ZON: "Zonal",
    REG: "Regional",
    COM: "Company Wide",
    INS: "Institutional",
    ADM: "Administration",
    MIN: "Ministry",
    PRO: "Professional",
    ACA: "Academic",
    MAN: "Management",
    CAM: "Others",
  };


  return (
    <MainLayout>
      <div className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Profile - My Think5Whys Processes</h2>
      </div>
      <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white'>
        <div className="flex justify-between mt-4 items-center border-b border-b-gray-300">
          <h3 className='text-lg mt-1 mx-2 text-white'>Processes I Created</h3>
          <button
            className='bg-purple-700'
            onClick={() => handleCreateProcessClick()}
            style={{ maxWidth: '150px' }}
          >
            Create New
          </button>
        </div>
        <div className="mt-4">
          {createdProcess.length === 0 ? (
            <div className='flex justify-center'>
              <p className='text-yellow-600 text-2xl mt-20 h-80'>You Have Not Created A Process Yet</p>
            </div>
          ) : (
            createdProcess.map((process, index) => (
              <div key={process._id} className='bg-gray-700 my-1 p-4 text-gray-600 rounded-md shadow-md'>
                <div className='flex'>
                  <span className='font-medium text-yellow-200'>
                    {index + 1}. {process.processTitle}
                  </span>
                  <Tooltip text={"View details"} position={"top"}>
                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleProcessView(process._id)}>
                      <i className="fa-solid fa-eye"></i>
                    </span>
                  </Tooltip>
                  <Tooltip text={"Add Process Members"} position={"top"}>
                    <span className='ml-2 text-blue-500 cursor-pointer' onClick={() => handleAddMembers(process._id)}>
                      <i className="fa-solid fa-user-plus"></i>
                    </span>
                  </Tooltip>
                  <Tooltip text={"View Process Members List"} position={"top"}>
                    <span className='ml-2 text-blue-500 cursor-pointer' onClick={() => handleViewMembers(process._id)}>
                      <i className="fa-solid fa-users"></i>
                    </span>
                  </Tooltip>
                </div>
                {selectedProcessId === process._id && (
                  <div className='bg-gray-600 text-black'>
                    <p><strong>Process Type:</strong> {processTypeNames[process.processType]}</p>
                    <p><strong>Created Date:</strong> {formatDateTime(process.dateCreated)}</p>
                    <p><strong>Description:</strong>{process.processDesc}</p>
                    <p><strong>Do's:</strong>{process.dos}</p>
                    <p><strong>Don't:</strong> {process.dont}</p>
                    <p><strong>Page:</strong> {process.processMicroPage}</p>
                    <p><strong>My Process Remarks:</strong> {process.myProcessRemarks}</p>
                    <p><strong>Master Process Code:</strong> {process.masterProcessCode}</p>
                    <p><strong>Master Process Title:</strong> {process.masterProcessTitle}</p>
                    <p><strong>Master Process Created By:</strong> {process.masterProcessCreator}</p>
                    <p><strong>Process Has Hierarchy:</strong> {process.isLevel ? "Yes" : "No"}</p>
                  </div>
                )}
                {selectedViewMemberProcessId === process._id && (
                  <div>
                    {process.myProcessMembers.length > 0 ? (
                      process.myProcessMembers.map((processmember, index) => (
                        <div key={index} className='bg-gray-200 text-black border-b border-b-yellow-300 mb-1'>
                          <p><strong>SN:</strong> {index+1}</p>
                          <p><strong>Member Name:</strong><span className="text-blue-500"> {processmember.name}</span></p>
                          <p><strong>Created Date:</strong> {formatDateTime(processmember.dateJoined)}</p>
                          <p><strong>Status:</strong> {processmember.isActive ? "Active" : "Left"}</p>
                        </div>
                      ))
                    ) : (
                      <div className='bg-gray-200 text-black'>
                        <p>No Other Member Found</p>
                      </div>
                    )}
                  </div>
                )}
                {selectedAddMemberProcessId === process._id && (
                  <div>
                    <div className='mb-4 flex text-wrap justify-center'>
                      <p className='text-white'>Input a 14 Characters Alphanumeric Think5Whys User Code Starting with TU:</p>
                    </div>
                    <div className="mb-4 flex justify-center">
                      <input
                        type="text"
                        name="newMemberCode"
                        id="newMemberCode"
                        value={newMemberCode}
                        placeholder="Input Referrer ID"
                        onChange={(e) => setNewMemberCode(e.target.value)}
                        className="h-12 text-center p-2 border border-gray-300"
                      />
                    </div>
                    <div className="mb-4 flex justify-center">
                      {error && <p className="text-red-800 justify-left">{error}</p>}
                    </div>
                    <div className='mb-4 flex flex-col items-center'>
                      <p className={newMemberCodeStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                        {newMemberCodeStatusMsg}
                      </p>
                      <button
                        type="button"
                        className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                        onClick={() => {
                          newMemberCodeValidationClicked(newMemberCode);
                          handleNewMemberCodeValidation();
                        }}
                        disabled={newMemberCodeStatus}
                      >
                        {newMemberCodeStatus ? "User ID Validated" : "Validate User ID"}
                      </button>
                    </div>
                    {newMemberCodeStatus && (
                      <div className="mb-2">
                        <div className="mb-4 text-lg text-white">
                          <div>
                            <div className='flex justify-center'>
                              <p className='text-xl text-green-500'>
                                User Code {newMemberCode} Validated for Process: 
                                <span>{process.processTitle}</span>
                              </p>
                            </div>
                            <div className='flex justify-center'>  
                              <button
                                type="button"
                                className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                onClick={() => {
                                  addNewButtonClicked(process._id, process.processCode, process.processTitle, processTypeNames[process.processType], newMemberId, newMemberCode, newMemberName );
                                }}
                                disabled={addNewMemberRecordStatus}
                              >
                                Add {newMemberName} To Process {process.processName}
                              </button>
                            </div>
                          </div>
                          <div className='flex justify-center'>
                              {addNewMemberRecordStatus ? (
                                <p className='text-xl text-green-500'>Member {newMemberName} Added To Your Process {process.processTitle}</p>
                                )  : (
                                  <p className='text-xl text-red-500'>Problem in adding Member {newMemberName} To Your Process {process.processTitle}</p>
                              )}
                            </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </MainLayout>
  );  
};

export default MyProcesses;


